import { FullscreenOutlined } from "@ant-design/icons";
import { Button, ButtonProps } from "antd";
import { usePaldockTranslation } from "hooks/usePaldockTranslation.tsx";
import { RefObject } from "react";

interface ExpandButtonProps {
    expandButtonRef: RefObject<() => void>;
    type?: ButtonProps["type"];
    size?: ButtonProps["size"];
    className?: string;
}

export const ExpandButton = ({ expandButtonRef, type, size = "small", className = "py-3" }: ExpandButtonProps) => {
    const { t } = usePaldockTranslation("common");

    return (
        <Button
            onClick={() => expandButtonRef.current?.()}
            type={type}
            size={size}
            className={className}
            icon={<FullscreenOutlined />}
        >
            {t("expand")}
        </Button>
    );
};
